import { useSceneEntities } from "@/stores/SceneEntities";
export function useAssetTub3053DualJetted(payload, viewport) {
 
  const sceneEntities = useSceneEntities();
  let assets = ["elite_3053_button_1", "elite_3053_button_2", "elite_3053_jets_whirlpool", "elite_3053_jets_hydro"];

  assets.forEach((value) => {
    let asset = sceneEntities.configuratorView.viewportComponent.getViewportAsset(value);    
    asset.enabled = payload.enabled;
    viewport.setEnabled(asset);
  });
}
